import { render, staticRenderFns } from "./ReportsTable.vue?vue&type=template&id=5cea52f6&scoped=true"
import script from "./ReportsTable.vue?vue&type=script&lang=js"
export * from "./ReportsTable.vue?vue&type=script&lang=js"
import style0 from "./ReportsTable.vue?vue&type=style&index=0&id=5cea52f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cea52f6",
  null
  
)

export default component.exports